'use client'

import React, { FC } from 'react'
import { SnipeShield } from '@/components/secure-listing-badge'

/** The green shield + "On" shown as the value of a "Snipe protection" invoice row. */
export const SnipeProtectionOn: FC = () => <SnipeShield label="On" />

/**
 * One invoice-style line on the single-item sell drawer, which has no
 * Invoice component. Not a control: protection is on whenever the API
 * offers it, and the bulk sell forms show the same fact as an Invoice row.
 */
const SnipeProtectionRow: FC<{ offered: boolean; note?: string | null }> = ({ offered, note }) => {
	if (!offered && !note) {
		return null
	}
	return (
		<div className="flex items-center justify-between text-xs text-muted-foreground" data-testid="snipe-protection-row">
			<span>Snipe protection</span>
			{offered ? <SnipeProtectionOn /> : <span>{note}</span>}
		</div>
	)
}

export default SnipeProtectionRow

/** The Invoice item the sell forms and buy invoices append when protection is on,
 *  plus the visible note when this asset type or output has no protection. */
export function snipeProtectionInvoiceItem(
	on: boolean,
	note?: string | null
): Array<{ title: string; value: React.ReactNode }> {
	const items: Array<{ title: string; value: React.ReactNode }> = []
	if (on) items.push({ title: 'Snipe protection', value: <SnipeProtectionOn /> })
	if (note) items.push({ title: 'Snipe protection', value: note })
	return items
}
